import React from 'react';

import classNames from 'classnames';
import { getPaginationPages } from 'src/common/utils';
import { v4 as uuidv4 } from 'uuid';

const MORE_PAGES = -1;

type ListPaginationProps = {
  totalCount: number;
  currentPage: number;
  setCurrentPage: (page: number) => void;
};

const ListPagination: React.FC<ListPaginationProps> = ({
  totalCount,
  currentPage,
  setCurrentPage,
}: ListPaginationProps) => {
  const pages = getPaginationPages(totalCount, currentPage);
  const isPrevDisabled = currentPage === 1;
  const isNextDisabled =
    (pages.length && currentPage === pages[pages.length - 1]) || totalCount === 0;

  const handleSetCurrentPage = (page: number) => () => {
    setCurrentPage(page);
  };

  return (
    <nav className="bg-white-0.0 flex items-center px-4 border-t border-white-2.0 pb-4 sm:pb-2 mt-auto flex-shrink-0">
      <div
        className={classNames(
          'flex items-center flex-1 pt-4 pr-1 -mt-px text-sm font-medium transition duration-150 ease-in-out cursor-pointer',
          isPrevDisabled && 'invisible'
        )}
        role="presentation"
        onClick={handleSetCurrentPage(currentPage - 1)}
      >
        <i className="icon-chevron_left_icon text-base" />
        <p className="ml-2">Previous</p>
      </div>
      <div className="md:flex hidden my-auto">
        {pages.map((p) =>
          p === MORE_PAGES ? (
            <span
              className="inline-flex items-center px-4 pt-4 -mt-px text-sm font-medium border-t-2 border-transparent"
              key={uuidv4()}
            >
              ...
            </span>
          ) : (
            <div
              role="presentation"
              className={classNames(
                ' focus:outline-none inline-flex items-center px-4 pt-4 -mt-px text-sm font-medium transition duration-150 ease-in-out cursor-pointer',
                currentPage === p
                  ? 'border-t-2 border-secondary-1.0'
                  : 'border-t-2 border-transparent hover:border-gray-1.0'
              )}
              onClick={handleSetCurrentPage(p)}
              key={uuidv4()}
            >
              {p}
            </div>
          )
        )}
      </div>
      <div
        className={classNames(
          'flex items-center justify-end flex-1 pt-4 pl-1 -mt-px text-sm font-medium transition duration-150 ease-in-out border-t-2 border-transparent cursor-pointer',
          isNextDisabled && 'invisible'
        )}
        role="presentation"
        onClick={handleSetCurrentPage(currentPage + 1)}
      >
        <p className="text-base">Next</p>
        <i className="icon-chevron_right_icon ml-2 text-base" />
      </div>
    </nav>
  );
};

export default ListPagination;
